import { createContext, useState } from 'react'

import {
  getStep,
  IDataContext,
  setCourse,
  setCpf,
  setDocument,
  setFormData,
  setCandidate,
  getStepPosition,
  getPreviousStep,
  getLastFilledStep,
  setRegistrationCode,
  setCode,
  setDate,
  setJWT,
} from './tools'
import { APP_ROUTES, IAppRoute } from '../routes'

const DEFAULT_VALUE: IDataContext = {
  registration: {
    candidate: undefined,
    cpf: undefined,
    document: '',
    code: '',
    date: undefined,
    jwt: undefined,
    course: undefined,
    minBirthdate: undefined,
    maxBirthdate: undefined,
    courseYear: undefined,
    courseTypeId: undefined,
    setCandidate,
    setDocument,
    setCpf,
    getStep,
    setCourse,
    getStepPosition,
    getPreviousStep,
    getLastFilledStep,
    setFormData,
    registration_code: '',
    setRegistrationCode,
    setCode,
    setDate,
    setJWT,
    steps: APP_ROUTES?.map((route: IAppRoute) => ({
      ...route,
      formData: null,
    })),
  },
  setRegistration: () => null,
}

const DataContext = createContext<IDataContext>(DEFAULT_VALUE)

const ContextDataProvider = (props: any) => {
  const [registration, setRegistration] = useState(DEFAULT_VALUE.registration)

  return (
    <DataContext.Provider value={{ registration, setRegistration }}>
      {props.children}
    </DataContext.Provider>
  )
}

export { ContextDataProvider, DEFAULT_VALUE }

export default DataContext
